import React from 'react';
import { Form, Button, Affix, Breadcrumb, Input } from 'antd';
import { Container, Paper, Toolbar, IconButton, Typography } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import MyLayout from './layout/layout';
import DragSortingUpload from '../components/DragSortingUpload';
import axios from '../AxiosInstance';
import { routeName } from '../routes/paths';
import useNotification from '../components/notification';
import { toSlug } from '../utils';

export default function EditBrand() {
  const { id } = useParams();

  const navigate = useNavigate();
  return (
    <MyLayout>
      <Container>
        <Toolbar sx={{ width: '100%', marginBottom: 3 }}>
          <IconButton
            size='small'
            onClick={() => {
              navigate(routeName.BRANDS);
            }}
            sx={{ marginRight: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant='h6' noWrap component='div' sx={{ flex: 1 }}>
            {id === 'add' ? 'Add Brand' : 'Edit Brand'}
          </Typography>
        </Toolbar>
        <BrandForm />
      </Container>
    </MyLayout>
  );
}

const BrandForm = () => {
  const [bottomCard, setBottomCard] = React.useState({ backgroundColor: 'transparent', boxShadow: 'none' });
  const [form] = Form.useForm();
  const { id } = useParams();
  const { TextArea } = Input;
  const navigate = useNavigate();
  const { sendNotification } = useNotification();

  const formItemLayout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 12,
    },
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  const onAffixChange = (affixed) => {
    setBottomCard(!affixed ? { backgroundColor: 'transparent', boxShadow: 'none' } : null);
  };

  const submitFormHandler = (values) => {
    const formData = new FormData();
    // console.log(values);˝
    if (id === 'add') {
      formData.append('brandPic', values.brandPic[0].originFileObj);
      formData.append('heroImage', values.heroImage[0].originFileObj);
      formData.append('name', values.name);
      formData.append('slug', values.slug);
      formData.append('description', values.description == 'undefined' ? '' : values.description);

      axios
        .post('/brands', formData)
        .then((res) => {
          // console.log(res.data);
          sendNotification({ msg: `Create new brand success`, variant: 'success' });
          navigate(routeName.BRANDS);
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Create Error`, variant: 'error' });
        });
    } else {
      if (!values.brandPic[0].url) formData.append('brandPic', values.brandPic[0].originFileObj);
      if (!values.heroImage[0].url) formData.append('heroImage', values.heroImage[0].originFileObj);

      formData.append('name', values.name);
      formData.append('description', values.description);
      formData.append('slug', values.slug);
      // console.log(formData);
      axios
        .put(`/brands/${id}`, formData)
        .then((res) => {
          // console.log(res.data);
          sendNotification({ msg: `Update brand success`, variant: 'success' });
          navigate(routeName.BRANDS);
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Update Error`, variant: 'error' });
        });
    }
  };

  const handleNameChange = (event) => {
    // console.log(event.target.value);
    let slugText = toSlug(event.target.value);

    form.setFieldsValue({
      slug: slugText,
    });
  };

  React.useEffect(() => {
    if (id !== 'add') {
      axios
        .get(`/brands/${id}`)
        .then((res) => {
          const brandDetail = res.data; // console.log(res.data);
          form.setFieldsValue({
            brandPic: [{ url: brandDetail.brandPic }],
            heroImage: [{ url: brandDetail.heroImage }],
            name: brandDetail.name,
            slug: brandDetail.slug,
            description: brandDetail.description,
          });
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Something Wrong`, variant: 'error' });
        });
    }
  }, []);

  return (
    <Form name='edit_brand' form={form} {...formItemLayout} onFinish={submitFormHandler}>
      <Form.Item
        name='brandPic'
        label='brand pic'
        valuePropName='fileList'
        getValueFromEvent={normFile}
        required
        help='รูปควรเป็น สี่เหลี่ยมจัตุรัส และขนาดไม่เกิน 2 MB'
        rules={[{ required: true, message: 'กรุณาระบุรูปแบรนด์' }]}>
        <DragSortingUpload maxCount={1} />
      </Form.Item>

      <Form.Item
        name='heroImage'
        label='hero image'
        valuePropName='fileList'
        getValueFromEvent={normFile}
        required
        help='รูปควรเป็นแนวนอนแบบ Cover Page ขนาด 1440x400 และขนาดไม่เกิน 2 MB'
        rules={[{ required: true, message: 'กรุณาระบุรูปหน้าปกแบรนด์' }]}>
        <DragSortingUpload maxCount={1} />
      </Form.Item>

      <Form.Item name='name' label='ชื่อ brand' required rules={[{ required: true, message: 'กรุณาระบุชื่อแบรนด์' }]}>
        <Input showCount placeholder='ชื่อแบรนด์' onChange={handleNameChange} />
      </Form.Item>

      <Form.Item name='slug' label='Slug' required rules={[{ required: true, message: 'กรุณาระบุ Slug URL' }]}>
        <Input placeholder='slug' />
      </Form.Item>

      <Form.Item name='description' label='description'>
        <TextArea showCount placeholder='รายละเอียด' style={{ height: 150 }} />
      </Form.Item>

      <Affix offsetBottom={0} onChange={onAffixChange}>
        <Paper sx={{ my: 2, pt: 3, pb: 1, ...bottomCard }} elevation={5}>
          <Form.Item
            wrapperCol={{
              span: 5,
              offset: 12,
            }}>
            <Button style={{ marginInline: 10 }}>Cancel</Button>
            <Button style={{ marginInline: 10 }} type='primary' htmlType='submit'>
              Submit
            </Button>
          </Form.Item>
        </Paper>
      </Affix>
    </Form>
  );
};
